import styled from 'styled-components';
import { Accordion, AccordionContent } from 'ui/accordion';
import { ErrorLabel } from 'ui/accordion/ErrorAccordion/ErrorAccordion.styled';
import { body2, captionBold, colors, fontSizes, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p344: pxToRem(344),
  p376: pxToRem(376),
};

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.plusHalf} ${spacing.double} ${spacing.base};
  max-width: calc(100vw - ${spacing.x4});
  gap: ${spacing.half};
  background-color: ${colors.grey1};
  top: 0;
  z-index: 20;
`;

export const HeaderTitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: ${spacing.half};
  max-width: calc(100vw - ${spacing.x8});
`;

export const HeaderToolbarSection = styled.div`
  display: flex;
  gap: ${spacing.half};
  position: relative;
  min-height: ${spacing.doubleHalf};
  min-width: ${customSpacing.p376};
  justify-content: flex-end;
`;

export const NameWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const ExperimentTypeSubheaderWrapper = styled.div`
  ${body2}
  display: flex;
  align-items: center;

  /* text/primary */
  color: ${colors.grey80};
`;

export const ErrorAccordionWrapper = styled.div`
  position: relative;
  min-width: ${customSpacing.p376};
  width: ${customSpacing.p376};
  max-width: ${customSpacing.p376};
`;

export const StyledAccordion = styled(Accordion)`
  position: absolute;
  padding: ${spacing.half} ${spacing.base};
  width: 100%;

  ${ErrorLabel} {
    margin-right: 0;
  }
`;

export const StyledAccordionContent = styled(AccordionContent)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const ErrorSectionHeaderWrapper = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
`;

export const ErrorHeaderText = styled.div`
  ${captionBold};
  font-size: ${fontSizes.s14};
`;

export const ErrorListWrapper = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  flex-direction: column;
  margin: ${spacing.quarter} 0 0 ${spacing.plusQuarter};
`;
